import { connect } from 'react-redux'
import { replace, goBack } from 'react-router-redux'
import at from 'lodash/at'
import values from 'lodash/values'
import sortBy from 'lodash/sortBy'
import IssueForm from '../../components/issues/issue-form'

import { createIssueForLocation } from '../../actions/issues'
import { setCurrentFilter } from '../../actions/areas'
import { fetchLocation } from '../../actions/locations'
import { loadAreasByLocation } from '../../actions/areas'
import { loadIssueDescriptions } from '../../actions/issue-descriptions'

import { issueDescriptionSelector } from '../../selectors/issue-description-selectors'
import moment from 'moment'

function mapStateToProps (state, ownProps) {
  const location = state.locations[ownProps.params.locationId]
  let selectedAreaIssueCount = 0

  if (!location) return { loading: true }

  const issueDescriptions = issueDescriptionSelector(state)

  if (state.form.hasOwnProperty('addEditIssue')) {
    const area = state.areas[state.form.addEditIssue.areaId.value]
    selectedAreaIssueCount = area ? area.issueCount : 0
  }

  return {
    modalTitle: 'Add Issue',
    submitButtonText: 'Add',
    issueDescriptions,
    location,
    selectedAreaIssueCount,
    newIssue: true,
    initialValues: {
      status: 'needs_work',
    }
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const locationId = ownProps.params.locationId

  dispatch(fetchLocation(locationId))
    .then(() => dispatch(loadAreasByLocation(locationId)))
    .then(() => dispatch(loadIssueDescriptions()))

  return {
    onSubmit (data) {
      data = {...data, timezone: moment.tz.guess()}

      return dispatch(createIssueForLocation(locationId, data))
        .then((action) => {

          if (action) {
            return action.error && Promise.reject({ _error: action.payload.errors[0] })
          } else {
            return false
          }
        })
        .then(action => dispatch(replace(`location-issues/${locationId}`)))
    },

    handleClose () {
      dispatch(goBack())
    },

    viewIssuesClicked (areaId) {
      dispatch(setCurrentFilter(areaId))
      dispatch(replace(`location-issues/${locationId}?allow_filtering=1`))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueForm)



// WEBPACK FOOTER //
// ./src/containers/issues/issue-create-container.js